import { BaseApi } from '@/providers';
import type { IMBEStore } from '@/types';

const COUPON_DETAILS_KEY = 'couponDetails';

export interface IStoresApi {
  getAll: (
    params: { nearLat?: number; nearLng?: number },
    options?: RequestInit
  ) => Promise<IMBEStore[]>;
  getStoreByCouponCode: (
    couponCode: string,
    shouldIncludeCouponDetails?: boolean
  ) => Promise<IMBEStore[]>;
}

export class StoresApi extends BaseApi implements IStoresApi {
  public async getAll(
    params: { nearLat?: number; nearLng?: number },
    options?: RequestInit
  ): Promise<IMBEStore[]> {
    const url = new URL(`${this.baseApiUrl}/stores`);

    if (params.nearLat !== undefined && params.nearLng !== undefined) {
      url.searchParams.append('nearLat', encodeURIComponent(params.nearLat));
      url.searchParams.append('nearLng', encodeURIComponent(params.nearLng));
    }

    const response = await fetch(url, options);

    const data = (await response.json()) as unknown;
    if (!response.ok) throw new Error((data as Error).message);
    return data as Promise<IMBEStore[]>;
  }

  public async getStoreByCouponCode(
    couponCode: string,
    shouldIncludeCouponDetails = false
  ): Promise<IMBEStore[]> {
    const url = new URL(`${this.baseApiUrl}/stores`);
    url.searchParams.append('couponCode', couponCode);

    if (shouldIncludeCouponDetails) {
      url.searchParams.append('include', COUPON_DETAILS_KEY);
    }

    const response = await fetch(url);

    if (!response.ok) {
      const errorData = (await response.json()) as Error;
      throw new Error(errorData.message || 'Failed to fetch store by coupon code');
    }

    return response.json() as Promise<IMBEStore[]>;
  }
}
